
export const common = {
  // Navigation
  home: "Inicio",
  about: "Acerca de Nosotros",
  services: "Servicios", 
  contact: "Contacto",
  language: "Idioma",
  
  // Common buttons
  learnMore: "Saber Más",
  getQuote: "Pide tu Cotización",
  contactUs: "Contáctanos",
  bookNow: "Reservar Ahora",
  sendMessage: "Enviar Mensaje",
  
  // Hero section
  heroTitle: "Servicios Profesionales de Traducción Legal",
  heroSubtitle: "Traducciones certificadas para documentos legales con precisión y confidencialidad. Sirviendo a Utah y más allá con servicios expertos de traducción legal bilingüe.",
  heroButton: "Obtenga Su Cotización Hoy",
  
  // Services
  servicesTitle: "Nuestros Servicios de Traducción",
  servicesSubtitle: "Soluciones integrales de traducción legal para todas sus necesidades documentales",
  
  service1Title: "Traducción de Documentos Legales",
  service1Desc: "Contratos, acuerdos, documentos judiciales y correspondencia legal traducidos con precisión y exactitud legal.",
  
  service2Title: "Traducción Certificada",
  service2Desc: "Traducciones certificadas oficiales para inmigración, propósitos académicos y legales aceptadas por tribunales y agencias gubernamentales.",
  
  service3Title: "Servicios de Interpretación",
  
  service3Desc: "Servicios profesionales de interpretación judicial para deposiciones, audiencias y procedimientos legales.",
  
  service4Title: "Documentos de Inmigración",
  service4Desc: "Traducción especializada de actas de nacimiento, certificados de matrimonio, diplomas y otros documentos relacionados con inmigración.",
  
  // Service features
  service1Feature1: "Documentos Biográficos",
  service1Feature2: "Registros Legales",
  service1Feature3: "Reportes Policiales",
  service1Feature4: "Registros Médicos",
  service1Feature5: "Declaraciones y Testimonios",
  service1Feature6: "Registros Académicos",

  service2Feature1: "Aceptado por USCIS",
  service2Feature2: "Corte de Inmigración (EOIR)",
  service2Feature3: "Transcripciones Académicas",
  service2Feature4: "Registros Médicos",
  service2Feature5: "Documentos Oficiales",

  service3Feature1: "Deposiciones",
  service3Feature2: "Entrevistas de USCIS",
  service3Feature3: "Citas Médicas",
  service3Feature4: "Procedimientos de Arbitraje",
  service3Feature5: "Entrevistas con Clientes",
  
  service4Feature1: "Actas de Nacimiento",
  service4Feature2: "Certificados de Matrimonio",
  service4Feature3: "Registros Académicos",
  service4Feature4: "Reportes Médicos",
  service4Feature5: "Declaraciones de Testigos",
  
  // About section
  aboutTitle: "Acerca de Vargas Legal Translation",
  aboutText: "Con años de experiencia en traducción legal, Javier Vargas Carrillo proporciona servicios de traducción profesionales, precisos y confidenciales. Nuestra experiencia asegura que sus documentos legales mantengan su validez legal y precisión entre idiomas.",
  
  // Professional Excellence section
  professionalExcellenceTitle: "Excelencia Profesional",
  professionalExcellenceText1: "Javier Vargas Carrillo aporta amplia experiencia en traducción legal, combinando un profundo conocimiento de los sistemas legales tanto en inglés como en español con meticulosa atención al detalle.",
  professionalExcellenceText2: "Javier se especializa en traducir documentos legales complejos y relacionados con inmigración, incluyendo documentos judiciales, médicos, educativos y oficiales, entregando traducciones confiables que preservan la integridad y significado del texto original.",
  
  // Testimonials
  testimonialsTitle: "Lo Que Dicen Nuestros Clientes",
  
  testimonial1: "Excelente servicio y atención al detalle. Javier tradujo nuestros contratos legales perfectamente y entregó a tiempo.",
  testimonial1Author: "María Rodríguez, Abogada de Inmigración",
  
  testimonial2: "Traducciones profesionales, confiables y precisas. Altamente recomendado para cualquier necesidad de traducción legal.",
  testimonial2Author: "David Thompson, Abogado Corporativo",
  
  testimonial3: "Calidad excepcional y entrega rápida. Vargas Legal Translation es nuestra opción principal para todas las traducciones de documentos.",
  testimonial3Author: "Ana Martínez, Firma Legal",
  
  // CTA section
  ctaTitle: "¿Listo para Comenzar?",
  ctaSubtitle: "Contáctenos hoy para servicios profesionales de traducción legal en los que puede confiar.",
  ctaButton: "Contáctenos Ahora",
  
  // Contact form
  contactTitle: "Póngase en Contacto",
  contactSubtitle: "¿Listo para discutir sus necesidades de traducción legal? Contáctenos hoy para una consulta gratuita.",
  getInTouch: "Póngase en Contacto",
  
  // Form labels and placeholders
  firstName: "Nombre",
  lastName: "Apellido",
  firstNamePlaceholder: "Ingrese su nombre",
  lastNamePlaceholder: "Ingrese su apellido",
  emailPlaceholder: "Ingrese su correo electrónico",
  phonePlaceholder: "Ingrese su número de teléfono",
  messagePlaceholder: "Cuéntenos sobre sus necesidades de traducción...",
  serviceNeeded: "Servicio Requerido",
  selectService: "Seleccione un servicio",
  legalTranslation: "Traducción Legal",
  immigrationDocuments: "Documentos de Inmigración",
  courtDocuments: "Documentos Judiciales",
  medicalRecords: "Registros Médicos",
  educationalDocuments: "Documentos Educativos",
  other: "Otro",
  characterLimit: "Máximo 500 caracteres",
  sending: "Enviando...",
  messageSuccess: "¡Gracias! Su mensaje ha sido enviado exitosamente. Nos pondremos en contacto pronto.",
  messageError: "Lo sentimos, hubo un error al enviar su mensaje. Inténtelo de nuevo o contáctenos directamente.",
  
  // Contact info
  contactInfo: "Información de Contacto",
  address: "Utah, Estados Unidos",
  email: "javier@vtraduccion.com",
  phone: "(385) 212-4967",
  instagram: "@vargas.legal.translation",
  
  // Contact info labels
  addressLabel: "Dirección",
  emailContactLabel: "Correo Electrónico",
  phoneContactLabel: "Teléfono",
  instagramLabel: "Instagram",
  
  // Business hours
  businessHours: "Horario de Atención",
  mondayFriday: "Lunes - Viernes",
  saturday: "Sábado",
  sunday: "Domingo",
  businessTime: "9:00 AM - 5:00 PM",
  byAppointment: "Con Cita Previa",
  closed: "Cerrado",
  
  // Footer
  footerText: "Servicios profesionales de traducción legal en Utah. Traducciones certificadas para documentos legales, papeles de inmigración y procedimientos judiciales.",
  allRightsReserved: "Todos los derechos reservados.",
  
  // About page
  aboutPageTitle: "Acerca de Javier Vargas Carrillo",
  aboutPageContent: "Javier Vargas Carrillo es un traductor profesional especializado en traducción de documentos legales con amplia experiencia en terminología legal tanto en inglés como en español. Con base en Utah, Javier proporciona servicios de traducción certificada para firmas legales, individuos y empresas que requieren traducciones de documentos precisas y legalmente conformes.",
  
  mission: "Nuestra Misión",
  missionText: "Asociarnos con profesionales legales proporcionando traducciones precisas, rápidas y confiables que le ahorren tiempo, fortalezcan la representación de clientes y le ayuden a ganar casos.",
  
  values: "Nuestros Valores",
  accuracy: "Precisión",
  accuracyText: "Cada traducción es meticulosamente revisada para precisión legal y lingüística.",
  confidentiality: "Confidencialidad", 
  confidentialityText: "Mantenemos protocolos estrictos de confidencialidad para proteger información legal sensible.",
  reliability: "Confiabilidad",
  reliabilityText: "Entrega oportuna y calidad consistente en la que puede confiar para todas sus necesidades de traducción legal.",
  
  // Process steps
  processTitle: "Nuestro Proceso de Traducción",
  processSubtitle: "Un enfoque sistemático que garantiza precisión y calidad en cada traducción",
  
  process1Title: "Revisión de Documento",
  process1Desc: "Evaluación inicial de sus documentos y requisitos de traducción",
  
  process2Title: "Cotización y Plazo",
  process2Desc: "Cotización detallada con precios transparentes y cronograma de entrega",
  
  process3Title: "Traducción",
  process3Desc: "Traducción profesional con atención a la terminología legal",
  
  process4Title: "Revisión de Calidad",
  process4Desc: "Revisión exhaustiva y certificación antes de la entrega final"
};

export default common;
